import * as React from 'react';
import { cloneDeep, entries, parseInt } from 'lodash';
import { ChannelConfigMeta } from '@interface/index';
import { NiCard, AddButton, NiSelect, NiInput } from '@component/index';
import { API, USER_CHANNEL_NAME_MAP, RESPONSE_CHANNEL_TYPE, INTEGRATION_TYPE } from '@config/index';
import { Layout, message, Space, Tabs, Input, Spin, Modal, Typography, Checkbox } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { RouteComponentProps } from 'react-router-dom';
import reactJsonView from 'react-json-view';
const ReactJsonView = reactJsonView;

const { Content } = Layout;

import './index.less';

export type ChannelConfigMetaCompProps = RouteComponentProps<{
}> & {};
export interface ChannelConfigMetaCompState {

  data: ChannelConfigMeta[];
  loading: boolean;
}

export class ChannelConfigMetaComp extends React.Component<ChannelConfigMetaCompProps, ChannelConfigMetaCompState> {
  state: ChannelConfigMetaCompState = {
    data: [],
    loading: false
  };

  listener: (() => void) | undefined;

  componentDidMount() {
    this.onInit();
  }

  onInit = async () => {
    this.setState({ loading: true });

    try {
      const tmps: any = await API.channelConfigMeta.getAll();

      this.setState({ data: Object.values(tmps) });
    } catch (err: any) {
      message.error(err.message);
    } finally {
      this.setState({ loading: false });
    }
  }

  componentWillUnmount() {
    if (this.listener) {
      this.listener();
    }
  }

  render() {
    const state = this.state;
    const {
      data,
      loading
    } = this.state;

    return (
      <Layout className="admin-layout"
      >
        <Spin spinning={loading}>
          <Content style={{ padding: 16, backgroundColor: 'white' }}>
            <NiSelect
              style={{ width: 400 }}
              value={undefined}
              placeholder={'New'}
              onChange={(value: string) => {
                this.addTemp({
                  channel_type: value,
                  class_name: '',
                  meta_data: ''
                });
              }}
            >
              {
                Object.entries(INTEGRATION_TYPE).map(([label, value]: [string, string]) =>
                  <NiSelect.Option
                    disabled={data.findIndex((item: ChannelConfigMeta) =>
                      item.channel_type === value) !== -1 || value === RESPONSE_CHANNEL_TYPE.RESTFUL}
                    value={value}
                    key={value}
                  >
                    {USER_CHANNEL_NAME_MAP[value]}
                  </NiSelect.Option>)
              }
            </NiSelect>
            {
              (data || []).map((tmp: ChannelConfigMeta, idx: number) =>
                <NiCard
                  key={tmp.channel_type}
                  style={{ marginBottom: 16 }}
                  title={USER_CHANNEL_NAME_MAP[tmp.channel_type]}
                  extra={<Space size={16}>
                    <Input
                      defaultValue={tmp.class_name}
                      placeholder="Class Name"
                      onBlur={(e: any) => {
                        tmp.class_name = e.target.value;
                        this.updateTemp(tmp);
                      }}
                    />
                    <DeleteOutlined
                      onClick={() => {
                        this.deleteTemp(tmp);
                      }}
                    />
                  </Space>}
                >
                  <Input.TextArea
                    rows={10}
                    defaultValue={tmp.meta_data}
                    placeholder="Meta JSON"
                    onBlur={(e: any) => {
                      tmp.meta_data = e.target.value;
                      this.updateTemp(tmp);
                    }}
                  />
                </NiCard>)
            }
          </Content>
        </Spin >
      </Layout >
    );
  }

  updateTemp = async (tmp: ChannelConfigMeta) => {
    this.setState({ loading: true });

    try {
      await API.channelConfigMeta.update(tmp);
      this.onInit();
    } catch (err: any) {
      message.warning(err.message);
    } finally {
      this.setState({ loading: false });
    }
  }

  addTemp = async (tmp: ChannelConfigMeta) => {
    this.setState({ loading: true });

    try {
      await API.channelConfigMeta.add(tmp);
      this.onInit();
    } catch (err: any) {
      message.warning(err.message);
    } finally {
      this.setState({ loading: false });
    }
  }

  deleteTemp = async (tmp: ChannelConfigMeta) => {
    this.setState({ loading: true });

    try {
      await API.channelConfigMeta.delete(tmp);
      this.onInit();
    } catch (err: any) {
      message.warning(err.message);
    } finally {
      this.setState({ loading: false });
    }
  }
}

export const ChannelConfigMetaPage = (props: any) => {
  return <ChannelConfigMetaComp {...props} />;
};

